import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import '../styles/navbar.css'

const Navbar = (props) => {
    function handleLogout() {
        props.setToken()
        window.location.replace("/");
    }

    function handleBist() {
        return <Redirect to={'/about'} />
    }

    return <div className="md:w-screen p-2 mb-2 border-bottom">
            <Link className="inline hover:text-red-300 transition-all text-lg font-bold" to={"/"}><span id="logo-text">Bist</span></Link>
            {props.loggedIn ?
                <div className="inline"> 
                    {
                    (props.isAbout && props.loggedIn) ?
                    <div className="inline"></div>
                    :
                    <Link to={'/about'} className={"hover:text-red-200 inline absolute right-20"}>About</Link>
                    }
                    {
                    (props.isAbout && props.loggedIn) ? 
                    <Link to={"/"} className="inline absolute right-2 cursor-pointer text-red-300 hover:text-red-400">Go Back &#8594;</Link>
                    :
                    <div className="inline absolute right-2 cursor-pointer hover:text-red-300" onClick={() => handleLogout()}>Logout</div>
                    }
                </div>
                :
                <div className="inline"> 
                    <Link to={"/about"} className="hover:text-red-200 inline absolute right-20 mr-3">About</Link>
                    <Link to={"/register"} className="inline absolute right-2 cursor-pointer hover:text-red-300">Register</Link>
                </div>            
            }
            </div>
}

export default Navbar